import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";

import OfferCard from "./OfferCard";

const StyledPricingSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding-top: 70px;
  padding-bottom: 70px;
  padding-left: 15px;
  padding-right: 15px;
  
  .offer-card-container {
  width: 30%;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: column;
    align-items: center;

    padding-top: 40px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .offer-card-container {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1024px) {
    width: 990px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
  @media (min-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 1170px;
  }
  @media (min-width: 1600px) {
    padding-left: 115px;
    padding-right: 115px;
    width: 1440px;
  }
`;

function PricingSection() {
  const [standardPrice, setStandardPrice] = useState("");
  const [rushPrice, setRushPrice] = useState("");
  const [oneHourPrice, setOneHourPrice] = useState("");

  useEffect(() => {
    axios
      .get(process.env.NEXT_PUBLIC_REACT_APP_API + "/category/EIN/products/prices?productCodes=EIN_SoleProp",
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) =>
        response.data.forEach((product) => {
          switch (product.option) {
            case "RUSH":
              setRushPrice(product.price);
              break;
            case "STANDARD":
              setStandardPrice(product.price);
              break;
            case "ONE_HOUR":
              setOneHourPrice(product.price);
              break;
            default:
          }
        })
      )
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <StyledPricingSection>
      <div className="offer-card-container">
        <OfferCard
          title="Standard delivery"
          description="1-2 Day Delivery Times"
          price={standardPrice}
          bullets={[
            "1-2 day Delivery Times",
            "Easy to Use EIN Application Wizard",
            "Free Changes & Update to your EIN",
            "Full in-depth human review of application",
            "Support from our trained EIN specialists - Available by Email or Phone",
          ]}
        />
      </div>
      <div className="offer-card-container">
        <OfferCard
          title="Rush Delivery"
          description="Same Day Delivery"
          price={rushPrice}
          bullets={[
            "EIN Delivered by 8PM EST or Rush fee is refunded",
            "Easy to Use EIN Application Wizard",
            "Free Changes & Updates to your EIN",
            "Full in-depth human review of application",
            "Support from our trained EIN specialists - Available by Email or Phone",
          ]}
        />
      </div>
      <div className="offer-card-container">
        <OfferCard
          title="1 Hour"
          description="1 hour delivery time"
          price={oneHourPrice}
          bullets={[
            "1 hour delivery time or Rush fee is refunded",
            "EIN number completion guarantee, if there are any issues, we fix them at no cost to you!",
            "Rest easy protection plan for any other issues that may come up regarding your we will take of it for you.",
            "+Unlimited updates or changes with your EIN Number",
            "Custom simplified online form",
            "In-depth Review by an EIN specialist",
            "Unlimited support for any problems (If you have to call into the IRS the typical wait time is over an hour if you can even get a hold of them)",
            "Free application submission to the IRS",
            "75% off on registering with the state  (there are separate filing fees that go directly to the state too)",
            "75% off using our registered agent service (this is to make sure you get all official mail and it’s required by every state to have a registered agent.",
            "Free 30 minute consulting ($125 value) with a business expert to help make sure you are off to a good start (upon request)",
            "Free 30 minute consulting ($100 value) with a tax specialist to make sure you are properly structuring yourself for taxes (upon request)",
            "An operating agreement (this is upon request)",
          ]}
        />
      </div>
    </StyledPricingSection>
  );
}

export default PricingSection;
